import * as React from 'react';
import type { WithTranslation as WithTranslationProps } from 'react-i18next';
import s from '../solution-page-views/solution-info/solution-info.scss';
import { PreviewMode } from './preview-context';
import { AddItem, Tooltip, Proportion } from '@wix/design-system';
import { composer } from '../../../component-decorators/composer';

export interface IIconWrapperProps extends Partial<WithTranslationProps> {
  src: string;
  size: string;
}

export const IconPreviewWrapper = composer()
  .withTranslation()
  .compose((props: React.PropsWithChildren<IIconWrapperProps>) => (
    <PreviewMode.Consumer>
      {(value) => {
        return value.isPreview && !props.src ? (
          <div
            style={{
              height: props.size,
              width: props.size,
            }}
          >
            <Tooltip
              appendTo="scrollParent"
              content={props.t('solution.preview.addiconToolTip')}
              flip={true}
            >
              <Proportion className={s.iconAvatar}>
                <AddItem onClick={() => onClickIconAdd(value.appId)} />
              </Proportion>
            </Tooltip>
          </div>
        ) : (
          props.children
        );
      }}
    </PreviewMode.Consumer>
  ));

const onClickIconAdd = (appId): void => {
  window.open(
    `https://dev.wix.com/dc3/my-apps/${appId}/market/info/basic-info`,
  );
};
